import { Component } from '@angular/core';
// import { NbSidebarService, NbSidebarState } from '@nebular/theme';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BreakpointObserver } from '@angular/cdk/layout';
import { AppHeaderComponent } from 'src/domains/theme/app/component/app-header/app-header.component';
import { RouterOutlet } from '@angular/router';
import { AppVerticalMenuComponent } from '../app-vertical-menu/app-vertical-menu.component';
import { CommonModule } from '@angular/common';
import { Observable, switchMap } from 'rxjs';

@UntilDestroy()
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  imports: [
    CommonModule,
    AppHeaderComponent,
    RouterOutlet,
    AppVerticalMenuComponent,
  ],
})
export class DashboardComponent {
  showSidebar: Observable<boolean>;
  open = true;
  constructor(private breakpointObserver: BreakpointObserver) {}
  ngOnInit(): void {
    this.showSidebar = this.breakpointObserver
      .observe(['(min-width: 992px)'])
      .pipe(
        untilDestroyed(this),
        switchMap(async (value) => value.matches),
      );
    // this.sidebarService
    //   .onToggle()
    //   .pipe(untilDestroyed(this))
    //   .subscribe(() => {
    //     if (!this.open) {
    //       this.sidebarService.compact('menu-sidebar');
    //     }
    //   });
  }

  // async toggleMenu() {
  //   this.sidebarState = await firstValueFrom(
  //     this.sidebarService.getSidebarState('menu-sidebar'),
  //   );
  //   if (this.sidebarState === 'compacted') {
  //     this.sidebarService.expand('menu-sidebar');
  //   } else {
  //     this.sidebarService.compact('menu-sidebar');
  //   }
  //   setTimeout(() => {
  //     window.dispatchEvent(new Event('resize'));
  //   }, 400);
  // }
  // sliderResponsiveHandler(device) {
  //   if (device === 'collapsed') {
  //     this.sidebarService.compact('menu-sidebar');
  //   }
  // }
}
